<template>
    <div class="table-responsive">
        <!-- <h5>Invoices</h5> -->
        <loader v-if="isLoading" />
        <b-table-simple v-else borderless hover class="list">
            <b-thead>
                <b-tr>
                    <b-th>Reference:</b-th>
                    <b-th>Total:</b-th>
                    <b-th>Balance:</b-th>
                    <b-th>Created:</b-th>
                    <b-th>Notes:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="inv in list" :key="inv.id">
                    <b-td>
                        <a :href="env.APPS + inv.ci_url">
                            {{ inv.name }}
                        </a>
                    </b-td>
                    <b-td> {{ _toCurrency(inv.total_amount) }} </b-td>
                    <b-td>
                        <span v-if="inv.status == 4">
                            {{ _toCurrency(0) }}
                        </span>
                        <span v-else>
                            {{ _toCurrency(inv.balance_amount) }}
                        </span>
                    </b-td>
                    <b-td> {{ _carbonDateDisplay(inv.start) }}</b-td>
                    <b-td> {{ inv.note }} </b-td>
                    <b-td class="text-right">
                        <spinner v-if="inv.isLoading" />
                        <b-dropdown
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                            right
                            v-else-if="
                                inv.status !== CBILLINGS.INVOICE.TYPE_REOPENED
                            "
                        >
                            <template v-slot:button-content>
                                <i class="cus-cog-down"></i>
                            </template>

                            <b-dropdown-item
                                href="#"
                                v-if="inv.is_paid"
                                @click="goToLink(inv.ci_url)"
                            >
                                <i class="cus-page-white-edit"></i>
                                View Invoice
                            </b-dropdown-item>

                            <b-dropdown-item
                                href="#"
                                v-if="
                                    permissions['billing.payment.create'] ==
                                        1 &&
                                    inv.status == CBILLINGS.INVOICE.TYPE_OPEN
                                "
                                @click="showNewPaymentModal(inv)"
                            >
                                <i class="cus-money"></i>
                                New Payment
                            </b-dropdown-item>

                            <b-dropdown-item
                                href="#"
                                v-if="
                                    inv.status !=
                                    CBILLINGS.INVOICE.TYPE_REOPENED
                                "
                                @click="showEmailModal(inv)"
                            >
                                <i class="cus-email"></i>
                                Email Invoice
                            </b-dropdown-item>

                            <b-dropdown-item
                                href="#"
                                @click="printInvoice(inv)"
                                v-if="
                                    inv.status !=
                                    CBILLINGS.INVOICE.TYPE_REOPENED
                                "
                            >
                                <i class="cus-printer"></i>
                                Print Invoice
                            </b-dropdown-item>

                            <b-dropdown-item
                                href="#"
                                v-if="
                                    _hasAccess('billing.invoice.sms') &&
                                    showSmsOption
                                "
                                @click="sendSMSInvoice(inv)"
                            >
                                <i class="cus-phone"></i>
                                Text (SMS) Invoice
                            </b-dropdown-item>

                            <b-dropdown-item
                                href="#"
                                @click="showWriteOffModal(inv)"
                                v-if="
                                    inv.status == CBILLINGS.INVOICE.TYPE_OPEN &&
                                    _hasAccess('billing.writeoff.create')
                                "
                            >
                                <i class="cus-page-white-put"></i>
                                Write Off
                            </b-dropdown-item>

                            <b-dropdown-item
                                href="#"
                                @click="markPaid(inv)"
                                v-if=" _hasAccess('billing.invoice.mark.paid')
                                    && (!inv.is_paid && inv.total_amount <= 0 && inv.active_invoice_items.length > 0 )"
                            >
                                <i class="cus-accept"></i>
                                Mark as Paid
                            </b-dropdown-item>

                            <b-dropdown-item
                                href="#"
                                v-if="
                                    permissions['billing.invoice.delete'] ==
                                        1 &&
                                    !inv.is_paid &&
                                    inv.status !=
                                        CBILLINGS.INVOICE.TYPE_REOPENED
                                "
                                @click="showDeleteModal(inv)"
                            >
                                <i class="cus-delete"></i>
                                Delete Invoice
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                </b-tr>
                <b-tr v-if="list.length == 0 && !isLoading">
                    <b-td colspan="6"><i>No records available</i></b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-pagination
            v-if="meta"
            v-show="meta.lastPage > 1"
            class="vet-pagination"
            align="right"
            v-model="meta.currentPage"
            :total-rows="meta.total"
            :per-page="meta.perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
            @change="getInvoices"
        />

        <modal-email
            modal-ref="modal-email-invoice"
            ref="modal-email-invoice"
            :invoice="selectedInvoice"
            :client="clientDetails"
        />
        <modal-delete
            modal-ref="modal-invoice-delete"
            ref="modal-invoice-delete"
            :invoice="selectedInvoice"
            @reload="getInvoices(1, true)"
        />

        <modal-new-payment
            ref="createPaymentWindow"
            @reload="getInvoices(1, true)"
            :invoice="selectedInvoice"
            :client="clientDetails"
        />

        <modal-send-SMS ref="sendSMSModal" />

        <modal-write-off
            modal-ref="modalWriteOff"
            ref="modalWriteOff"
            :invoice="selectedInvoice"
            @reload="getInvoices(1, true)"
        />

        <exportPrintPdf
            v-if="selectedInvoice"
            ref="exportPrintPdf"
            :invoice="selectedInvoice"
            :client="clientDetails"
            @show-loading="
                isLoading => {
                    selectedInvoice.isLoading = isLoading;
                }
            "
        />
    </div>
</template>
<script>
import Billings from "@/services/client-billings";
import CBILLINGS from "@/constants/billings";
import Loader from "@/components/elements/loader-list";

export default {
    components: {
        Loader,
        ModalDelete: () =>
            import("@/components/client-invoices/invoice-delete-modal"),
        ModalEmail: () =>
            import("@/components/client-invoices/invoice-email-modal"),
        ModalNewPayment: () => import("@/components/new-payment/payment-modal"),
        ModalWriteOff: () =>
            import("@/components/client-invoices/invoice-write-off"),
        ModalSendSMS: () =>
            import("@/components/invoice-sms/modal-invoice-send-sms"),
        Spinner: () => import("@/components/elements/spinner"),
        ExportPrintPdf: () =>
            import("@/components/billing-export/export-print-pdf.vue")
    },
    props: {
        billingType: {
            type: Number
        }
    },
    data() {
        return {
            CBILLINGS,
            list: [],
            isLoading: false,
            selectedInvoice: { name: null, balance_amount: null },
            currentPage: 1,
            meta: null
        };
    },
    computed: {
        clientId() {
            return this.$store.state.client.client_id;
        },
        permissions() {
            return this.$root.permissions;
        },
        clientDetails() {
            return this.$store.getters["client/clientDetails"];
        },
        showSmsOption() {
            return (
                this._isExtensionEnabled("SMS") ||
                this._isExtensionEnabled("2_WAY_MESSAGING")
            );
        }
    },
    mounted() {
        this.getInvoices();
    },
    methods: {
        getInvoices(page, refreshClientProfile) {
            this.isLoading = true;

            if (refreshClientProfile) {
                this.$store.dispatch("client/getClientDetails", {
                    id: this.clientId
                });
            }

            let params = {
                page: page ? page : 1,
                perPage: this.PER_PAGE,
                type: this.billingType
            };

            Billings.getBillings(this.clientId, params)
                .then(response => {
                    this.list = response.resources.map(item => ({
                        ...item,
                        isLoading: false
                    }));
                    this.meta = response.meta;
                    this.isLoading = false;
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to get invoice list",
                        "danger"
                    );
                    this.isLoading = false;
                    console.error(error);
                });
        },
        goToLink(url) {
            window.location.href = process.env.CI_APPS + url;
        },
        async showEmailModal(invoice) {
            invoice.isLoading = true;
            await this.$store.dispatch("client/getClientDetails", {
                id: this.clientId
            });
            this.selectedInvoice = invoice;
            await this.$nextTick();
            invoice.isLoading = false;
            this.$refs["modal-email-invoice"].open();
        },
        async showDeleteModal(invoice) {
            invoice.isLoading = true;
            this.selectedInvoice = invoice;
            await this.$nextTick();
            if (invoice.active_invoice_items.length > 0) {
                let date = this._fromDateCarbon(invoice.start).toFormat("X");

                this.$store
                    .dispatch("checkBillingLock", {
                        date,
                        onProceed: () =>
                            this.$refs["modal-invoice-delete"].open(),
                        onError: message => this._message(message, "danger")
                    })
                    .finally(() => {
                        invoice.isLoading = false;
                    });
            } else {
                this.$refs["modal-invoice-delete"].open();
                invoice.isLoading = false;
            }
        },
        async showNewPaymentModal(invoice) {
            this.selectedInvoice = invoice;
            await this.$nextTick();
            this.$refs.createPaymentWindow.open();
        },
        async sendSMSInvoice(invoice) {
            this.selectedInvoice = invoice;
            await this.$nextTick();
            this.$refs.sendSMSModal.open(this.selectedInvoice.id);
        },
        showWriteOffModal(invoice) {
            this.selectedInvoice = invoice;
            this.$nextTick(() => {
                this.$refs.modalWriteOff.open();
            });
        },
        async printInvoice(invoice) {
            let self = this;
            self.selectedInvoice = invoice;
            await this.$nextTick();
            self.$refs.exportPrintPdf.init();
        },
        markPaid(invoice) {
            invoice.isLoading = true;
            // const proceedFn = () => {
            let formData = new FormData();
            formData.append("id", invoice.id);

            Billings.markPaidInvoice(formData)
                .then(response => {
                    if (response.state == 0) {
                        this._message(response.message);
                        this.getInvoices(1);
                    } else {
                        this._message(response.message, "danger");
                    }
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to mark invoice as paid",
                        "danger"
                    );
                    console.error(error);
                })
                .finally(() => {
                    invoice.isLoading = false;
                });
            // };

            // this.$store.dispatch('checkBillingLock', {
            //     date: new Date(invoice.create_at.date).getTime().toString().substr(0,10),
            //     onProceed: proceedFn,
            //     onError: (message) => this._message(message, 'danger')
            // });
        }
    }
};
</script>
